export function currentUserHasRole(role) {
  return window.roles.includes(role);
};
